import { render, staticRenderFns } from "./ReSendPayItem.vue?vue&type=template&id=18c3dc63&scoped=true"
import script from "./ReSendPayItem.vue?vue&type=script&lang=js"
export * from "./ReSendPayItem.vue?vue&type=script&lang=js"
import style0 from "./ReSendPayItem.vue?vue&type=style&index=0&id=18c3dc63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c3dc63",
  null
  
)

export default component.exports